import { Avatar, MyAvatar } from 'components/avatar/Avatar'
import { SContentContainer, SUnboundAvatarsContainer } from './ContactNotificationModal.styled'
import { useActualContact } from 'components/contact/contactUtils'
import { Text, Title } from 'components/Typography'
import BrokenHeart from 'images/extra-svg/BrokenHeart.svg'
import React from 'react'
import { ApiType } from 'utils/types'

type NotificationContact = ApiType['TrustedContactResponse'] | ApiType['TrustedContactUserResponse']
type NotificationContactKind = 'trusted-contact' | 'trusted-contact-user'

type ContactUnboundModalProps = {
  contact?: NotificationContact
  contactKind?: NotificationContactKind
}

export const ContactUnboundModal = (props: ContactUnboundModalProps) => {
  const isTrustedContact = props.contactKind !== 'trusted-contact-user'
  const { actualContact: trustedContact } = useActualContact(
    isTrustedContact ? (props.contact as ApiType['TrustedContactResponse'] | undefined) : undefined
  )
  const actualContact =
    trustedContact ??
    (!isTrustedContact
      ? (props.contact as ApiType['TrustedContactUserResponse'] | undefined)
      : undefined)
  const contactType = isTrustedContact
    ? (props.contact as ApiType['TrustedContactResponse'] | undefined)?.user?.type
    : (props.contact as ApiType['TrustedContactUserResponse'] | undefined)?.type
  return (
    <SContentContainer>
      <SUnboundAvatarsContainer css={{ marginTop: '2.5rem' }}>
        <MyAvatar size={120} />
        <BrokenHeart />
        <Avatar owner={actualContact} size={120} />
      </SUnboundAvatarsContainer>
      <Title variant="h7">{`You are no longer ${
        actualContact?.first_name || actualContact?.email
      }'s ${contactType === 'LEGACY_CONTACT' ? 'Legacy Contact' : 'Trusted Contact'}`}</Title>
      <Text>
        {`We felt it was important to let you know that this person has removed you as a ${
          contactType === 'LEGACY_CONTACT' ? 'Legacy' : 'Trusted'
        } Contact.`}
      </Text>
    </SContentContainer>
  )
}
